module.exports = __webpack_public_path__ + "img/org_ter.63921a85.svg";